module.exports = "data:application/octet-stream;base64,cHJhZ21hIHNvbGlkaXR5IF4wLjQuMTg7CgppbXBvcnQgInplcHBlbGluLXNvbGlkaXR5L2NvbnRyYWN0cy9vd25lcnNoaXAvT3duYWJsZS5zb2wiOwoKY29udHJhY3QgTGV2ZWwgaXMgT3duYWJsZSB7CiAgZnVuY3Rpb24gY3JlYXRlSW5zdGFuY2UoYWRkcmVzcyBfcGxheWVyKSBwdWJsaWMgcGF5YWJsZSByZXR1cm5zIChhZGRyZXNzKTsKICBmdW5jdGlvbiB2YWxpZGF0ZUluc3RhbmNlKGFkZHJlc3MgX2luc3RhbmNlLCBhZGRyZXNzIF9wbGF5ZXIpCiAgICBwdWJsaWMKICAgIHJldHVybnMgKGJvb2wpOwp9Cg=="


//////////////////
// WEBPACK FOOTER
// ./contracts/levels/base/Level.sol
// module id = 1348
// module chunks = 0